export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  image_url: string;
  additional_images?: string[];
  category: string;
  unit: string;
  in_stock: boolean;
  is_new?: boolean;
  is_bestseller?: boolean; // Ручной бейдж "Хит продаж"
  base_quantity?: number;
  created_at: string;
  // Акции
  discount_percent?: number;
  discount_start?: string;
  discount_end?: string;
}

// Хелпер для проверки активности акции
export const isDiscountActive = (product: Product): boolean => {
  if (!product.discount_percent || product.discount_percent <= 0) return false;
  
  const now = new Date();
  
  if (product.discount_start) {
    const start = new Date(product.discount_start);
    if (now < start) return false;
  }
  
  if (product.discount_end) {
    const end = new Date(product.discount_end);
    if (now > end) return false;
  }
  
  return true;
};

// Расчёт цены со скидкой
export const getDiscountedPrice = (product: Product): number => {
  if (!isDiscountActive(product)) return product.price;
  return Math.round(product.price * (1 - (product.discount_percent || 0) / 100));
};

export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
}

export interface CartItem {
  product: Product;
  quantity: number;
  customUnit?: string; // Произвольная единица, например "0.5 кг"
}
